import { connect } from 'react-redux';

import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { templatesActions } from '../../settings/actions/templates';
import { actions } from '../actions/conversation';
import NoteForm from '../components/NoteForm';

const mapStateToProps = (state) => {
  const metaConversation = state.conversation.metaConversation;
  return {
    csid: metaConversation.conversation.id,
    agentId: state.settings.profile.profile.id,
    tempWrapup: metaConversation.tempWrapup,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    conversationAddWrapup: bindActionToPromise(
      dispatch,
      actions.conversationAddWrapup,
    ),
    templatesRender: bindActionToPromise(
      dispatch,
      templatesActions.templatesRender,
    ),
    conversationSaveTempWrapup: (csid: string, message: string) =>
      dispatch(
        actions.conversationSaveTempWrapup({ csid: csid, message: message }),
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NoteForm);
